import { roomService } from '../network/services/room.service';
import moment from 'moment';

let start = moment();
if (start.format('HHmmss') > '220000') {
  start = moment(start.add(1, 'days').format('YYYY-MM-DD') + 'T17:00:00+0000')
}

export const MIN_DATE_MOMENT = start;

export default {
  namespaced: true,
  state: {
    loading: false,
    input: {
      fromDate: start.toDate(),
      toDate: start.clone().add(1, 'd').toDate(),
      searchString: '',
      traveler: {
        adults: 2,
        children: 0,
        babies: 0
      },
      equipments: [],
      isBusiness: false,
      businessCode: '',
      hasInfant: false,
      sameDate: false
    },
    sameDate: false,
    hasData: false,
    roomIds: [-1],
    dates: [-1],
    nbGuest: -1,
  },
  mutations: {
    SET_LOADING(state, payload) {
      payload = !!payload;
      if (payload) {
        state.roomIds = [-1];
        state.dates = [-1];
        state.traveler = {
          adults: 2,
          children: 0,
          babies: 0
        };
        state.equipments = [];
        state.hasData = false;
        state.sameDate = false;
      }
      state.loading = payload;
    },
    SET_SAME_DATE (state, payload) {
      state.sameDate = !!payload;
      state.input.sameDate = !!payload;
    },
    SET_RESULT(state, payload) {
      state.hasData = true;
      state.roomIds = payload.roomIds;
      state.dates = payload.dates;
      state.traveler = payload.traveler;
    },
    SET_ROOM_IDS(state, payload) {
      state.roomIds = payload;
    },
    SET_INPUT(state, payload) {
      state.input = payload;
    },
    SET_INPUT_ROOMNAME(state, payload) {
      state.input.searchString = payload
    }
  },
  actions: {
    async select(context, roomIds) {
      await context.dispatch('fetch', context.rootState.preFetchRoom.input);
      context.commit('SET_ROOM_IDS', context.rootState.preFetchRoom.roomIds.filter(r => roomIds.indexOf(r) !== -1));
    },
    async fetch(context, { fromDate, toDate, equipments, traveler, isBusiness, businessCode, hasInfant, searchString }) {
      const sameDate = moment(fromDate).format('YYYYMMDD') === moment(toDate).format('YYYYMMDD');
      context.commit('SET_SAME_DATE', sameDate)
      context.commit('SET_INPUT', { fromDate, toDate, traveler, isBusiness, equipments, businessCode, hasInfant, searchString, sameDate });
      context.commit('SET_LOADING', true);
      try {
        const result = await roomService.fetchRoomAvailability({ fromDate, toDate, traveler, equipments, isBusiness, businessCode, hasInfant, searchString, sameDate });
        context.commit('SET_RESULT', result.result);
      } catch (e) {
         context.commit('SET_RESULT', {
           roomIds: [],
           dates: [],
           traveler: traveler
         })
      } finally {
        context.commit('SET_LOADING', false);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/pre-fetch-room.store.js